module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccess),
      expression: "showSuccess"
    }],
    staticClass: "sc-result-box sc-result-box-overlay",
    style: (("display: block;z-index:" + (_vm.highestZIndex + 8)))
  }, [_c('div', [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Purchase_Success.png"),
      "alt": "Payment Success"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Purchase Successful")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.resultMessage)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(".".repeat(_vm.ScRedirectLoader)))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3feef886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaySuccessComponent.vue
// module id = 110
// module chunks = 0